import { base } from '@/app/editor/sidebar/constant';
import { app } from '@/store';
/**
 * get data from <section class ="data"> trong divContentBk
 * @param {string} moduleId chuỗi số id dạng string
 * @returns {string} có dạng {"items": []}
 */
export const getModuleData = (moduleId: string): string => {
  let $data: any = '';
  const keyData = `${base._data}-module-${moduleId}`;
  $data = (app as any).$store.getters['editor/GET_DATA_SETTING_BY_KEY'](keyData);

  let data = $data;

  // Fix: Nếu data không có giá trị thì gán mặc định
  if (!data) {
    data = '{"items": []}';
  }

  const replaces = [];
  const reg = new RegExp(/font-family(.*?;)/g);
  let result;
  while ((result = reg.exec(data)) !== null) {
    const font = result[0].replace(/\\"/g, '"');
    replaces.push(font);
  }
  for (let i = 0; i < replaces.length; i++) {
    const oldFont = replaces[i];
    const newFont = oldFont.replace(/"/g, '');
    data = data.replace(oldFont, newFont);
  }
  return data;
};
